import { CalendarOutlined } from '@ant-design/icons';
import { lazyRouteComponent } from '@tanstack/react-router';

import { ACCOUNT_ROLE_CODES } from '@lib/types';
import { Route } from '@lib/types/route';

import { ROUTE_PATHS } from '../route-paths';

const EventsPage = lazyRouteComponent(() => import('./pages/list'));
const EventDetailsPage = lazyRouteComponent(() => import('./pages/details'));
const AdminEventsPage = lazyRouteComponent(() => import('./pages/admin-list'));

export const getPublicRoutes = (): Route[] => [
  {
    path: ROUTE_PATHS.EVENTS,
    page: EventsPage,
    title: 'Eventos',
    public: true,
    allowUnverified: true,
    hidden: true,
  },
  {
    path: ROUTE_PATHS.EVENT_DETAILS,
    page: EventDetailsPage,
    title: 'Evento',
    public: true,
    allowUnverified: true,
    hidden: true,
  },
];

export const getRoutes = (): Route[] => [
  {
    path: ROUTE_PATHS.ADMIN_EVENTS,
    page: AdminEventsPage,
    title: 'Eventos',
    icon: CalendarOutlined,
    adminSection: 'operation',
    adminOrder: 25,
    acl: [ACCOUNT_ROLE_CODES.ADMIN],
  },
];
